import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Environment } from '@td/core';

@Component({
  template: '',
})
export class RootRedirectComponent {
  private readonly router = inject(Router);
  private readonly environment = inject(Environment);

  constructor() {
    void this.router.navigate([this.getRedirectPath()], { replaceUrl: true });
  }

  private getRedirectPath(): string {
    switch (this.environment.name) {
      case 'production:federal':
      case 'training:federal':
        return '/login/usdc-federal';
      default:
        return '/login';
    }
  }
}
